// Map legacy DB exam/subject/filiere colors to a cohesive Nomad-inspired palette
const REMAP = {
  "#F2A900": "#FFB800",
  "#B56576": "#EC4899",
  "#6D597A": "#7C3AED",
  "#355070": "#05357E",
  "#D97757": "#FF4B0A",
  "#2E7D32": "#10B981",
  "#247BA0": "#2563EB",
  "#E56B6F": "#EF4444",
  "#1B4965": "#042A65",
  "#595959": "#0891B2",
  "#2B4C3B": "#042A65",
  "#5FA8D3": "#0EA5E9",
  "#62B6CB": "#06B6D4",
  "#2E8C9E": "#0891B2",
};

export const remap = (hex) => (hex && REMAP[hex.toUpperCase()]) || hex || "#FF4B0A";
